// CustomMailNotificationContent.js
import React from 'react';
import NotificationSnackbarLayout from '../common/NotificationSnackbarLayout';

const CustomMailNotificationContent = React.forwardRef((props, ref) => {
  const { message, closeSnackbar } = props;
  const notification = message;

  const isUnread = !notification?.email?.isRead;
  const primaryLine = notification?.email?.from || 'Unknown';
  const secondaryLine = notification?.email?.subject || '';

  return (
    <NotificationSnackbarLayout
      ref={ref}
      closeSnackbar={closeSnackbar}
      isUnread={isUnread}
      avatarSrc={notification?.email?.avatarUrl || '/images/user.png'}
      avatarChildren={notification?.email?.from ? notification.email.from.charAt(0) : ''}
      primaryLine={primaryLine}
      secondaryLine={secondaryLine}
      bodyText={notification?.email?.text || 'No content available'}
      captionDate={new Date(notification?.createdAt || Date.now()).toLocaleString()}
    />
  );
});

CustomMailNotificationContent.displayName = 'CustomMailNotificationContent';
export default CustomMailNotificationContent;
